import { ref } from 'vue';

export const draggingItem = ref(null);

export function setDraggingItem(item) {
  draggingItem.value = item;
}

export function clearDraggingItem() {
  draggingItem.value = null;
}
